/* eslint-disable no-console */
export const quietLogsInProdEnv = () => {
    if (process.env.NODE_ENV === 'production') {
        console.log = function () {}
        console.info = function () {}
    }
}
